const uuidv4 = require("uuid/v4");

export default {
  install: function(Vue) {
    Object.defineProperty(Vue.prototype, "$uuidv4", { value: uuidv4 });
  }
};
